import React, { useRef } from 'react';
import AsyncSelect from 'react-select/async';
import apiFetch from '@wordpress/api-fetch';

const organisePublicationsById = (publicationsOrPublication) => {
    const publicationsById = {};
    const isArray = Array.isArray(publicationsOrPublication);
    const publications = isArray ? publicationsOrPublication : null;
    const publication = !isArray ? publicationsOrPublication : null;

    if (publications) {
        publications.forEach((publication) => publicationsById[publication.ID] = publication);
    }
    if (publication) {
        publicationsById[publication.ID] = publication;
    }
    return publicationsById;
}

export const PostSelector = ({ onChange, ...props }) => {
    const publicationsOrPublication = props.value;
    const value = Array.isArray(publicationsOrPublication)
        ? publicationsOrPublication.map((publication) => ({ label: publication.post_title, value: publication.ID }))
        : publicationsOrPublication
            ? { label: publicationsOrPublication.post_title, value: publicationsOrPublication.ID }
            : null;
    const publicationsRef = useRef(organisePublicationsById(publicationsOrPublication));

    const handleChange = (selectedOption) => {
        const publicationsById = publicationsRef.current;

        const value = selectedOption && selectedOption?.length
            ? selectedOption.map(publication => publicationsById[publication.value])
            : selectedOption
                ? publicationsById[selectedOption?.value]
                : null;

        return onChange(value);
    };

    const loadOptions = (
        inputValue,
        callback
    ) => {
        apiFetch({ path: `/v1/get/publications?search=${inputValue}&limit=30&only_experience_tags=false` }).then((data) => {
            const publications = (data.publications || []);

            // map publications by id
            publications.forEach((publication) => { publicationsRef.current[publication.ID] = publication });

            callback(publications.map((publication) => ({ label: publication.post_title, value: publication.ID })));
        });
    };

    return (
        <AsyncSelect
            {...props}
            value={value}
            loadOptions={loadOptions}
            onChange={handleChange}
            isClearable
            cacheOptions
        />)
}

export default PostSelector